import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { Button } from '@digital/ui';
import { excluir } from '@app/api/RegraSubstituto';

export interface propsButtonExcluir {
    regraId: string;
    updatePage: any;
}

const ButtonExcluir = (props: propsButtonExcluir) => {
    const { regraId, updatePage } = props;

    const handleSubmit = (values: any) => {
        excluir(regraId).then(data => {
            if (data) {
                updatePage();
            }
        });
    };

    return (
        <>
            <Tooltip title="Excluir">
                <Button
                    onClick={() => {
                        handleSubmit({ regraId });
                    }}
                    name="btnExcluir"
                    confirm={'Deseja realmente excluir?'}
                    okText={"Excluir"}
                    icon="ui-delete"
                />
            </Tooltip>
        </>
    );
};
export default ButtonExcluir; 